function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["children", "theme", "locale", "navigate", "hideOnSinglePage", "card", "collapse", "form", "spin", "table", "tabs", "styleProviderProps", "appProps"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { App, ConfigProvider as AntConfigProvider } from 'antd';
import { StyleProvider } from '@ant-design/cssinjs';
import StyleContext from '@ant-design/cssinjs/es/StyleContext';
import { CaretRightOutlined } from '@oceanbase/icons';
import aliyunTheme from '@oceanbase/aliyun-theme';
import { merge } from 'lodash';
import StaticFunction from "../static-function";
import themeConfig from "../theme";
import defaultTheme, { fontFamilyEn } from "../theme/default";
import darkTheme from "../theme/dark";
import DefaultRenderEmpty from "./DefaultRenderEmpty";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export * from "./navigate";
export * from 'antd/es/config-provider/context';
export * from 'antd/es/config-provider/SizeContext';
export * from 'antd/es/config-provider/DisabledContext';
export * from 'antd/es/config-provider';
var ExtendedConfigContext = /*#__PURE__*/React.createContext({
  navigate: undefined,
  hideOnSinglePage: false,
  injectStaticFunction: true
});
var ConfigProvider = function ConfigProvider(_ref) {
  var _mergedTheme$token, _parentContext$pagina;
  var children = _ref.children,
    theme = _ref.theme,
    locale = _ref.locale,
    navigate = _ref.navigate,
    hideOnSinglePage = _ref.hideOnSinglePage,
    card = _ref.card,
    collapse = _ref.collapse,
    form = _ref.form,
    spin = _ref.spin,
    table = _ref.table,
    tabs = _ref.tabs,
    styleProviderProps = _ref.styleProviderProps,
    appProps = _ref.appProps,
    restProps = _objectWithoutProperties(_ref, _excluded);
  // inherit from parent ConfigProvider
  var parentContext = React.useContext(AntConfigProvider.ConfigContext);
  var parentExtendedContext = React.useContext(ExtendedConfigContext);
  var _merge = merge({}, parentContext.theme, theme),
    isDark = _merge.isDark,
    isAliyun = _merge.isAliyun;
  var customTheme = isAliyun ? aliyunTheme : isDark ? darkTheme : undefined;
  var mergedTheme = merge({}, customTheme ? {} : defaultTheme, parentContext.theme, customTheme, theme);
  var _themeConfig$useToken = themeConfig.useToken(),
    token = _themeConfig$useToken.token;
  var fontFamily = ((_mergedTheme$token = mergedTheme.token) === null || _mergedTheme$token === void 0 ? void 0 : _mergedTheme$token.fontFamily) || token.fontFamily;

  // inherit from parent StyleProvider
  var parentStyleContext = React.useContext(StyleContext);
  var mergedStyleProviderProps = merge({}, parentStyleContext, styleProviderProps);
  var mergedLocale = merge({}, parentContext.locale, locale);
  return /*#__PURE__*/_jsx(AntConfigProvider, _objectSpread(_objectSpread({
    locale: mergedLocale,
    card: merge({}, parentContext.card, card),
    collapse: merge({}, {
      expandIcon: function expandIcon(_ref2) {
        var isActive = _ref2.isActive;
        return /*#__PURE__*/_jsx(CaretRightOutlined, {
          rotate: isActive ? 90 : 0
        });
      }
    }, parentContext.collapse, collapse),
    form: merge({}, {
      requiredMark: 'optional'
    }, parentContext.form, form),
    spin: merge({}, parentContext.spin, spin),
    table: merge({}, parentContext.table, table),
    tabs: merge({}, {
      indicatorSize: function indicatorSize(origin) {
        return origin >= 24 ? origin - 16 : origin;
      }
    }, parentContext.tabs, tabs),
    theme: merge({}, mergedTheme, {
      token:
      // custom fontFamily
      fontFamily !== defaultTheme.token.fontFamily ? {
        fontFamily: fontFamily
      } :
      // use fontFamilyEn for en
      ['en', 'en-gb'].includes(mergedLocale.locale) ? {
        fontFamily: fontFamilyEn
      } : {}
    }),
    renderEmpty: parentContext.renderEmpty || function (componentName) {
      return /*#__PURE__*/_jsx(DefaultRenderEmpty, {
        componentName: componentName
      });
    }
  }, restProps), {}, {
    children: /*#__PURE__*/_jsx(ExtendedConfigContext.Provider, {
      value: {
        navigate: navigate === undefined ? parentExtendedContext.navigate : navigate,
        hideOnSinglePage: (_parentContext$pagina = parentContext.pagination) !== null && _parentContext$pagina !== void 0 && _parentContext$pagina.showSizeChanger ? false : hideOnSinglePage !== undefined ? hideOnSinglePage : parentExtendedContext.hideOnSinglePage,
        // inject static function to outermost ConfigProvider only
        injectStaticFunction: false
      },
      children: /*#__PURE__*/_jsx(StyleProvider, _objectSpread(_objectSpread({}, mergedStyleProviderProps), {}, {
        children: /*#__PURE__*/_jsxs(App, _objectSpread(_objectSpread({
          component: false
        }, appProps), {}, {
          children: [children, parentExtendedContext.injectStaticFunction && /*#__PURE__*/_jsx(StaticFunction, {})]
        }))
      }))
    })
  }));
};
ConfigProvider.ConfigContext = AntConfigProvider.ConfigContext;
ConfigProvider.ExtendedConfigContext = ExtendedConfigContext;
ConfigProvider.SizeContext = AntConfigProvider.SizeContext;
ConfigProvider.config = AntConfigProvider.config;
ConfigProvider.useConfig = AntConfigProvider.useConfig;
if (process.env.NODE_ENV !== 'production') {
  ConfigProvider.displayName = AntConfigProvider.displayName;
}
export default ConfigProvider;